import { describe, expect,it } from 'vitest';

import { CARD_CATEGORIES } from '../../../../../../../shared/cardConfig/constants';
import { PAYER_ADDRESS_FIELDS } from '../../../../../../../shared/fieldConfig/constants';
import { PAGE_ROUTES } from '../../../../../../../utils/constants';
import pages from '..';
import { Card, Page } from '..';


describe('Payer (Financial) Page Template Config', () => {
  it('exports one page', () => {
    expect(Array.isArray(pages)).toBe(true);
    expect(pages).toHaveLength(1);
  });

  const financialPage = (pages as Page[]).find(
    (p) => p.route === PAGE_ROUTES.financial
  ) as Page;

  describe('Financial Page Structure', () => {
    it('has correct route', () => {
      expect(financialPage.route).toBe(PAGE_ROUTES.financial);
    });

    it('contains cards array', () => {
      expect(Array.isArray(financialPage.cards)).toBe(true);
      expect(financialPage.cards.length).toBeGreaterThan(0);
    });
  });

  describe('Card Validations', () => {
    it('contains payer card with hideSameAs true', () => {
      const payerCard = financialPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.payer
      ) as Card;

      expect(payerCard).toBeDefined();
      expect(payerCard.hideSameAs).toBe(true);
      expect(Array.isArray(payerCard.fields)).toBe(true);
      expect(payerCard.fields).toHaveLength(3);
    });

    it('payer card has required taxNumber1 field', () => {
      const payerCard = financialPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.payer
      ) as Card;

      const taxField = payerCard.fields?.find(
        (f) => f.key === PAYER_ADDRESS_FIELDS.taxNumber1
      );

      expect(taxField).toBeDefined();
      expect(taxField?.required).toBe(true);
    });

    it('contains financialAttachmentCard', () => {
      const attachmentCard = financialPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.financialAttachmentCard
      ) as Card;

      expect(attachmentCard).toBeDefined();
      expect(attachmentCard.fields).toHaveLength(1);
    });

    it('contains additionalAttachmentCard', () => {
      const additionalAttachment = financialPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.additionalAttachmentCard
      ) as Card;

      expect(additionalAttachment).toBeDefined();
      expect(additionalAttachment.fields).toHaveLength(1);
    });

    it('contains privacyPolicy card without fields', () => {
      const privacyCard = financialPage.cards.find(
        (c) => c.key === CARD_CATEGORIES.privacyPolicy
      ) as Card;

      expect(privacyCard).toBeDefined();
      expect(privacyCard.fields).toBeUndefined();
    });
  });
});